import keyFigureHighchartsOptions from "../../../models/keyFigure/rendering/keyFigureHighchartsOptions.js";
import keyFigureValueFormatter from "../../../models/keyFigure/rendering/keyFigureValueFormatter.js";
import LegendWidget from "../../../core/widgets/LegendWidget.js";

/**
 * `MultipleKeyFiguresLegendsWidget` is a subclass of `LegendWidget` with support
 * for late setting so that the legend can be built after the widget
 * creation.
 *
 * @param {Period} currentPeriod - Period the keyfigures are to be referring to.
 */
export default class MultipleKeyFiguresLegendsWidget extends LegendWidget {
	constructor({ currentPeriod }) {
		super(...arguments);

		this._currentPeriod = currentPeriod;
		this._chart.setLegend(this);
	}

	setCurrentPeriod(period) {
		this._currentPeriod = period;
	}

	setLegendsFor(keyFigures) {
		const options = keyFigures.map((keyFigure) => {
			const highchartOptions =
				keyFigureHighchartsOptions[keyFigure.getId()];
			const activeColor =
				keyFigure.getChartColorOption() ||
				highchartOptions?.color ||
				"#7CB5EC";
			return {
				title: keyFigure.getName(),
				seriesId: keyFigure.getIdentifier(),
				value: "-",
				legendItemClass: "col-lg-3 col-sm-6 col-xs-6 col-xxs-12",
				valueRenderer: keyFigureValueFormatter.formatterFor(keyFigure),
				inactiveColor: "#999999",
				activeColor,
			};
		});

		this._setItems(options);
		this.update();
	}

	setResult(result) {
		result.getKeyFigures().forEach((keyFigure) => {
			const item = this._items.find(
				// eslint-disable-next-line no-shadow -- bad practice, we should fix this
				(item) => item.getSeriesId() === keyFigure.getIdentifier(),
			);
			const value = result.getValueForComponentInPeriod(
				keyFigure,
				this._currentPeriod,
			);

			item.setValue(value.getValue());
		});
	}

	clear() {
		this._items = [];
		this.update();
	}
}
